module.exports = __webpack_public_path__ + "img/MadeByTheCommunity_White.6fdf932a.png";